import React from 'react';
import { useQuery } from "react-query";

import * as helpers from '../../utils/utils.js';

import { usePrices } from '../../hooks/usePrices.js';
import { useUnits } from '../../hooks/useUnits.js';

function AvailableTableRow({ slot }) {
    const { retrieveUnitById } = useUnits();
    const { retrievePriceById } = usePrices();
    const {
      data: unit,
      error: unitError,
      isLoading: unitIsLoading,
    } = useQuery(["unitData", slot?.unitId], () => retrieveUnitById(slot.unitId), {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });
  
    const {
      data: price,
      error: priceError,
      isLoading: priceIsLoading,
    } = useQuery(["priceData", slot?.priceId], () => retrievePriceById(slot.priceId), {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });
  
    if (unitIsLoading || priceIsLoading) return <td colSpan={4}>Loading...</td>;
    if (unitError) return <td colSpan={4}>Error: {unitError.message}</td>;
    if (priceError) return <td colSpan={4}>Error: {priceError.message}</td>;
  
    if (slot && unit && price) return (
      <>
        <td className='unit'>{unit.name}</td>
        <td className='name'>N/A</td>
        <td className='time'>{helpers.formatTimeRange(price.startTime.hours, price.startTime.minutes, price.duration)}</td>
        <td className='price'>${price.price}</td>
        <td className="status">{slot.status}</td>
      </>
    );
}

export default AvailableTableRow;